function ConfirmationModalCtrl($scope, $uibModalInstance, $timeout, modalHeader, modalMessage, confirmBtnTxt, confirmingBtnTxt, cancelBtnTxt, deferred, confirmingBtnClass, hideCancelBtn) {
  _initScope();

  function _initScope() {
    $scope.modalHeader = modalHeader;
    $scope.modalMessage = modalMessage;
    $scope.confirmBtnTxt = confirmBtnTxt;
    $scope.confirmingBtnTxt = confirmingBtnTxt;
    $scope.confirmingBtnClass = confirmingBtnClass;
    $scope.hideCancelBtn = hideCancelBtn;
    $scope.cancelBtnTxt = cancelBtnTxt;

    $scope.confirm = _confirm;
    $scope.close = _close;
  }

  function _confirm($event) {
    if ($event) $event.preventDefault();

    $scope.saving = true;

    $timeout(() => {
      deferred.resolve(true);
    }, 100);
  }

  function _close() {
    deferred.resolve(false);
  }
}

ConfirmationModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  '$timeout',
  'modalHeader',
  'modalMessage',
  'confirmBtnTxt',
  'confirmingBtnTxt',
  'cancelBtnTxt',
  'deferred',
  'confirmingBtnClass',
  'hideCancelBtn'
];

export default ConfirmationModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/confirmation/controller.js